import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M277.974095,49.0764867 C343.241473,-16.3028415 449.706783,-16.4147924 515.421964,49.0764867 L515.421964,49.0764867 L747.608139,281.262662 L1803.30517,1337.07164 L1919.95801,1920 L1337.02965,1803.34716 L386.902325,853.331783 L466.051615,774.182494 L1267.84399,1575.86292 L1575.82093,1267.88598 L668.45885,360.411952 L281.220672,747.65013 L49.0344961,515.463954 C-16.344832,449.860724 -16.344832,343.395414 49.0344961,278.016086 L49.0344961,278.016086 Z M1654.97022,1347.03527 L1346.99328,1655.01221 L1392.1095,1700.12842 L1777.10866,1777.15065 L1700.08643,1392.15149 L1654.97022,1347.03527 Z M675.355026,596.258922 L1367.65942,1288.56331 L1288.51013,1367.7126 L596.205736,675.408211 L675.355026,596.258922 Z M396.642054,111.880944 C382.312338,111.880944 368.094573,117.254587 357.123385,128.225776 L357.123385,128.225776 L128.183785,357.165375 C106.46531,378.883851 106.46531,414.484238 128.183785,436.314665 L128.183785,436.314665 L281.220672,589.351551 L589.30956,281.262662 L436.272674,128.225776 C425.301486,117.254587 410.97177,111.880944 396.642054,111.880944 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEditLine = /*#__PURE__*/function (_Component) {
  _inherits(IconEditLine, _Component);

  var _super = _createSuper(IconEditLine);

  function IconEditLine() {
    _classCallCheck(this, IconEditLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconEditLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEdit",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconEditLine.displayName = "IconEditLine";
  return IconEditLine;
}(Component);

IconEditLine.glyphName = 'edit';
IconEditLine.variant = 'Line';
IconEditLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEditLine;
export { IconEditLine };